import {
    translateComment,
    translateEventDetail,
} from '@/components/page-components/fixtures/fixture-events/helperEvents';
import CustomTooltip from '@/DesignSystem/components/tooltip/CustomTooltip';
import useEventIcon from '@/DesignSystem/hooks/fixtures/useEventIcon';
import { Box, Typography } from '@mui/material';

const JugadorEventCard = ({ event, player, direction = 'row', includeTime = true }) => {
    const isPrimary =
        (event.player?.id === player.id && event.type !== 'subst') ||
        (event.assist?.id === player.id && event.type === 'subst');

    const eventIcon = useEventIcon({
        type: event.type,
        detail: event.detail,
        isRemoved: event.isRemoved,
        isPrimary,
        size: 12,
    });

    const comment = translateComment(event.comments, '-');
    const detail = translateEventDetail(event.detail, isPrimary);

    const label = `Min ${event.time?.elapsed}: ${detail} ${comment}`;
    const time = event.time?.elapsed;

    return (
        <CustomTooltip label={label}>
            <Box
                display="flex"
                alignItems="center"
                mr={direction === 'row' ? 0.25 : 0}
                ml={direction === 'row-reverse' ? 0.25 : 0}
                flexDirection={direction}
                sx={{ cursor: 'pointer' }}
            >
                {eventIcon}
                {(includeTime || event.type === 'subst') && (
                    <Typography
                        fontSize={10}
                        textAlign="center"
                        noWrap
                        sx={{ position: 'relative', top: '2px', color: '#fff' }}
                    >
                        {time}
                    </Typography>
                )}
            </Box>
        </CustomTooltip>
    );
};

export default JugadorEventCard;
